<template>
    <div>
        <div class="content">
            <div class="header">
                <span>{{title}}</span>
            </div>
            <div class="divider"></div>
            <div class="subheader">
                <div>
                    <span>
                        {{l10nAtJabrutouch}}
                    </span>
                </div>
            </div>
            <div class="subsubheader">
                <div>
                    <span>{{l10nSubText}}</span>
                </div>
            </div>

            <form class="form" @submit.prevent="handleSubmit">
                <div class="form-row">
                    <div class="label-row" :class="nameValidationClassObj">
                        <span>{{l10nFullName}} *</span>
                    </div>
                    <div class="input-row">
                        <input type="text" v-model="formModel.name" :class="nameValidationClassObj">
                    </div>
                </div>
                <div class="form-row">
                    <div class="label-row" :class="countryValidationClassObj">
                        <span>{{l10nCountry}} *</span>
                    </div>
                    <div class="input-row">
                        <input type="text" v-model="formModel.country" :class="countryValidationClassObj">
                    </div>
                </div>
                <div class="form-row">
                    <div class="label-row" :class="emailValidationClassObj">
                        <span>{{l10nEmail}} *</span>
                    </div>
                    <div class="input-row">
                        <input type="text" v-model="formModel.email" :class="emailValidationClassObj">
                    </div>
                </div>
                <div class="form-row">
                    <div class="label-row" :class="telephoneValidationClassObj">
                        <span>{{l10nTelephone}} *</span>
                    </div>
                    <div class="input-row">
                        <input type="text" v-model="formModel.telephone" :class="telephoneValidationClassObj">
                    </div>
                </div>
                <div class="form-action-section">
                    <jabra-btn dark :type="'submit'">
                        <span v-if="isLoading" class="form-submit"><font-awesome-icon :icon="['fal', 'spinner-third']"
                                                                                      spin/></span>
                        <span v-else class="form-submit">{{submitButtonText}}</span>
                    </jabra-btn>
                </div>
            </form>
        </div>
        <div class="bottom-colored-section-container">
            <div class="bottom-colored-section">
            </div>
        </div>
    </div>

</template>

<script>
    import {
        SET_THANK_YOU_POPUP_SHOW_STATE,
        CONTACT_COMPONENT_MODE_DEFAULT,
        CONTACT_COMPONENT_MODE_DEDICATION_MASECHET,
        CONTACT_COMPONENT_MODE_DEDICATION_YEAR,
        CONTACT_COMPONENT_MODE_DEDICATION_DAY,
        CONTACT,
        LOADING_PRISTINE,
        LOADING_STARTED,
        LOADING_COMPLETED_FAILURE,
        LOADING_COMPLETED_SUCCESS,
        SET_CONTACT_STATE,
        ROUTE_DEDICATION_DAY,
    } from '../services/constants'
    import helpers from '../services/helpers'
    import lodash from '../services/lodash'

    const formModelTemplate = {
        name: '',
        country: '',
        email: '',
        telephone: '',
    }
    export default {
        name: 'contact-component',
        data: function () {
            return {
                formModel: null,
                touched: {
                    form: false,
                }
            }
        },
        computed: {
            routeName() {
                return this.$router.currentRoute.name
            },
            mode() {
                switch (this.routeName) {
                    case 'dedicationMasechet':
                        return CONTACT_COMPONENT_MODE_DEDICATION_MASECHET
                    case 'dedicationYear':
                        return CONTACT_COMPONENT_MODE_DEDICATION_YEAR
                    case ROUTE_DEDICATION_DAY:
                        return CONTACT_COMPONENT_MODE_DEDICATION_DAY
                    default:
                        return CONTACT_COMPONENT_MODE_DEFAULT
                }
            },
            title() {
                switch (this.mode) {
                    case CONTACT_COMPONENT_MODE_DEDICATION_MASECHET:
                        return this.l10nDedicateAMasechet
                    case CONTACT_COMPONENT_MODE_DEDICATION_YEAR:
                        return this.l10nDedicateAYearOfLearning
                    case CONTACT_COMPONENT_MODE_DEDICATION_DAY:
                        return this.l10nSponsorDay
                    default:
                        return this.l10nContactUs
                }
            },
            contactState() {
                return this.$store.state.userModule.contact
            },
            isLoading() {
                return this.contactState.state === LOADING_STARTED
            },
            submitButtonText() {
                if (this.contactState.state === LOADING_COMPLETED_FAILURE) {
                    return this.l10nTryAgain
                }
                return this.l10nSubmit
            },
            l10nDedicateAMasechet() {
                return this.l10nGetter('dedicate_a_masechet')
            },
            l10nDedicateAYearOfLearning() {
                return this.l10nGetter('dedicate_a_year_of_learning')
            },
            l10nSponsorDay() {
                return this.l10nGetter('sponsor_day')
            },
            l10nContactUs() {
                return this.l10nGetter('contact_us')
            },
            l10nAtJabrutouch() {
                return this.l10nGetter('at_jabrutouch')
            },
            l10nSubText() {
                return this.l10nGetter('contact_form_sub_text')
            },
            l10nFullName() {
                return this.l10nGetter('full_name')
            },
            l10nCountry() {
                return this.l10nGetter('country')
            },
            l10nEmail() {
                return this.l10nGetter('email')
            },
            l10nTelephone() {
                return this.l10nGetter('telephone')
            },
            l10nSubmit() {
                return this.l10nGetter('submit')
            },
            l10nTryAgain() {
                return this.l10nGetter('try_again')
            },
            mergedFormModel() {
                const formClone = lodash.cloneDeep(this.formModel)
                formClone['subject'] = this.title
                return formClone
            },
            isNameValid() {
                return this.formModel.name.length > 0
            },
            showNameValidationUI() {
                return !this.isNameValid && this.shouldShowValidationUI
            },
            nameValidationClassObj() {
                return {
                    [this.invalidClassName]: this.showNameValidationUI
                }
            },
            isCountryValid() {
                return this.formModel.country.length > 0
            },
            showCountryValidationUI() {
                return !this.isCountryValid && this.shouldShowValidationUI
            },
            countryValidationClassObj() {
                return {
                    [this.invalidClassName]: this.showCountryValidationUI
                }
            },
            isEmailValid() {
                return this.formModel.email.length > 0
            },
            showEmailValidationUI() {
                return !this.isEmailValid && this.shouldShowValidationUI
            },
            emailValidationClassObj() {
                return {
                    [this.invalidClassName]: this.showEmailValidationUI
                }
            },
            isTelephoneValid() {
                return this.formModel.telephone.length > 0
            },
            showTelephoneValidationUI() {
                return !this.isTelephoneValid && this.shouldShowValidationUI
            },
            telephoneValidationClassObj() {
                return {
                    [this.invalidClassName]: this.showTelephoneValidationUI
                }
            },
            isFormValid() {
                return this.isNameValid
                    && this.isCountryValid
                    && this.isEmailValid
                    && this.isTelephoneValid
            },
            shouldShowValidationUI() {
                return Object.keys(this.touched).some(key => {
                    return this.touched[key]
                })
            },
            invalidClassName() {
                return 'invalid'
            }
        },
        methods: {
            handleSubmit() {
                this.touched.form = true
                if (this.isFormValid) {
                    this.$store.dispatch(CONTACT, this.mergedFormModel).then(() => {
                        if (this.contactState.state === LOADING_COMPLETED_SUCCESS) {
                            this.resetForm()
                            this.$store.commit(SET_THANK_YOU_POPUP_SHOW_STATE, true)
                        }
                    })
                }
            },
            resetForm() {
                this.formModel = lodash.cloneDeep(formModelTemplate)
                Object.keys(this.touched).forEach(key => {
                    this.touched[key] = false
                })
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
        },
        created() {
            this.resetForm()
        },
        destroyed() {
            this.$store.commit(SET_CONTACT_STATE, {
                state: LOADING_PRISTINE,
                data: null,
                error: null,
            });
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 700px;
        padding: 70px 0 220px;
        margin: 0 auto;
    }

    .header {
        text-transform: uppercase;
        @include font-abraham(50px, $font-color-blue, 400);
        margin: 0 0 20px 0;
    }

    .subheader {
        text-align: center;
        text-transform: uppercase;
        @include font-abraham(30px, $font-color-blue, 300);
        margin: 0 0 20px 0;
    }

    .subsubheader {
        text-align: center;
        @include font-abraham(28px, $font-color-blue, 300);
        margin: 0 0 20px 0;
    }

    .divider {
        width: 120px;
        height: 8px;
        margin: 30px;
        background: $accent-1;
    }

    .form {
        margin: 120px 0 0 0;
        width: 100%;
    }

    .form-row {
        margin: 0 0 35px 0;
        padding: 0 30px;
    }

    .label-row {
        @include font-abraham(15px, $grey-1, 400);
        margin: 0 0 15px 0;

        &.invalid {
            color: $warning-1;
        }
    }

    .input-row {
        input {
            @include font-abraham(30px, $grey-1, 300);
            line-height: 50px;
            width: 100%;

            &.invalid {
                border-left: 2px solid $warning-1;
            }
        }
    }

    .form-action-section {
        display: flex;
        justify-content: flex-end;
    }

    .form-submit {
        font-size: 20px;
        line-height: 50px;
        padding: 0 30px;
    }

    .bottom-colored-section-container {
        z-index: -1;
        position: relative;
    }

    .bottom-colored-section {
        background: rgb(220, 233, 239);
        height: 134px;
        width: 100%;
        position: absolute;
        bottom: 0;
    }


</style>
